import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { UserService } from '../../core/services/user.service';

type Provider = 'spotify' | 'youtube' | undefined;

@Component({
  selector: 'app-oauth-success',
  templateUrl: './oauth-success.page.html',
  styleUrls: ['./oauth-success.page.scss']
})
export class OauthSuccessPage implements OnInit, OnDestroy {
  provider: Provider;
  status?: string | null;
  linked?: boolean;
  loading = true;
  success = false;
  error?: string | null;
  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.provider = this.route.snapshot.queryParamMap.get('provider') as Provider;
    this.status = this.route.snapshot.queryParamMap.get('status');
    this.linked = this.route.snapshot.queryParamMap.get('linked') === 'true';

    if (!this.authService.token) {
      this.handleError('Please sign in to link your account.', '/auth/login');
      return;
    }

    const statusOk = this.status === 'success';
    const sub = this.userService.loadMe().subscribe({
      next: user => {
        this.userService.setUser(user);
        this.success = statusOk && !!this.linked;
        this.loading = false;
        if (!this.success) {
          this.error = 'We could not link your account. Please try again.';
        }
        setTimeout(() => this.router.navigateByUrl('/app/account'), 1400);
      },
      error: err => {
        const message =
          err?.error?.message ||
          (err?.status === 401 ? 'Session expired. Please sign in again.' : 'We could not refresh your account.');
        this.handleError(message, err?.status === 401 ? '/auth/login' : undefined);
      }
    });

    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  goToAccount(): void {
    this.router.navigateByUrl('/app/account');
  }

  private handleError(message: string, redirect?: string): void {
    this.error = message;
    this.loading = false;
    if (redirect) {
      setTimeout(() => this.router.navigateByUrl(redirect), 1200);
    }
  }
}
